<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">Add Categorized Estimator</h3>
            <button @click="closeModal" class="closeIcon" style="width: 40px;height: 40px;"><span></span></button>
        </div>
        <div class="card-body">
            <p>Here you can add a categorized estimator.</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'addCategorized',
    data() {
        return {
            // Add any data properties needed for the categorized estimator
        };
    },
    methods: {
        closeModal() {
            this.$parent.$emit('closed-lateral');
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
